module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.isHtmlEdit ? 'Edit Html Hint' : 'Add Html Hint'))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "py-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Position/Name",
      "items": _vm.listItems,
      "hide-details": ""
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), (_vm.formData.name !== 'webshop.logo' && _vm.formData.name !== 'webshop.headerImage.mobile') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "py-2": ""
    }
  }, [_c('div', {
    staticClass: "pa-2",
    staticStyle: {
      "border": "1px solid #757575",
      "border-radius": "4px"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Html Code"
    },
    model: {
      value: (_vm.formData.value),
      callback: function($$v) {
        _vm.$set(_vm.formData, "value", $$v)
      },
      expression: "formData.value"
    }
  })], 1)]) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-0": "",
      "py-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "p-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.logoPreview,
      "contain": "",
      "max-height": "200",
      "max-width": "389"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    ref: "logoField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "hide-details": "",
      "label": _vm.$lang.labels.upload
    },
    on: {
      "click": function($event) {
        return _vm.startInput()
      }
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('input', {
    ref: "logoInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitHtmlCode()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da971254","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/HtmlHintsModal.vue
// module id = 600
// module chunks = 23